module.exports = __webpack_public_path__ + "media/images/jito-logo-28fb06da.svg";